import * as React from 'react';
import PropTypes from 'prop-types';
import { Backdrop, Box, CircularProgress } from '@mui/material';
import useStyles from './styles';

export default function Loader({
  children,
  ownProps,
  loader,
  size,
  backdrop,
  flex,
  flexCentered,
  centeredX,
  centeredY,
  offsetRight,
}) {
  const classes = useStyles();

  return (
    loader[ownProps.target]
      ? (
        <Box className={`${flex && classes.flex} ${flexCentered && classes.flexCentered}`}>
          <Backdrop
            className={classes.backdrop}
            open={(loader && backdrop) || false}
          />
          <CircularProgress
            size={size}
            className={`${classes.loader} ${centeredX && classes.centeredX} ${centeredY && classes.centeredY}`}
            style={{
              display: flex ? 'flex' : 'block',
              right: `-${offsetRight}px`,
            }}
          />
        </Box>
      )
      : children || null
  );
}

Loader.defaultProps = {
  backdrop: false,
  flex: false,
  flexCentered: false,
  centeredX: false,
  centeredY: false,
  children: null,
  ownProps: {},
  offsetRight: false,
};

Loader.propTypes = {
  children: PropTypes.objectOf(PropTypes.any),
  ownProps: PropTypes.objectOf(PropTypes.any),
  loader: PropTypes.objectOf(PropTypes.bool).isRequired,
  target: PropTypes.string.isRequired,
  backdrop: PropTypes.bool,
  flex: PropTypes.bool,
  flexCentered: PropTypes.bool,
  centeredX: PropTypes.bool,
  centeredY: PropTypes.bool,
  size: PropTypes.number.isRequired,
  offsetRight: PropTypes.number,
};
